<template>
  <Transition>
    <FinancialInsightsModalView
      v-if="modalRoute && timelineEntryId"
      v-bind="{
        timelineEntryId
      }"
    />
  </Transition>
</template>

<script lang="ts" setup>
import useModalRoute from "@cosine/composables/useModalRoute";
import { RouteName } from "@cosine/routes";
import FinancialInsightsModalView from "@cosine/views/FinancialInsightsModalView.vue";
import { computed } from "vue";

const {
  modalRoute,
} = useModalRoute(RouteName.insightsView);

const timelineEntryId = computed(() => {
  return modalRoute.value?.params.timelineEntryId?.toString();
});
</script>
